import Vue from 'vue'
import store from '../store.js'
import VueI18n from 'vue-i18n'
import en from './en'
import gr from './gr'
// import es from './es'
// import de from './de'
// import cr from './cr'
// import fr from './fr'
// import it from './it'
// import ru from './ru'
import bg from './bg'
import nl from './nl'
// import da from './da'
// import no from './no'
// import pt from './pt'
// import se from './se'

Vue.use(VueI18n)

export default new VueI18n({
  locale: store.state.locale,
  fallbackLocale: 'en',
  messages: {
    en: en,
    gr: gr,
    // ru: ru,
    bg: bg,
    // es: es,
    // de: de
    // cr: cr,
    // fr: fr,
    // it: it,
    nl: nl
    // da: da,
    // no: no,
    // pt: pt,
    // se: se
  }
})



// WEBPACK FOOTER //
// ./src/lang/lang.js